import React, { useState, useEffect } from "react";
import axios from "../../utils/axios";
import Select from "react-select";
import { HiClipboardList} from "react-icons/hi";
import Topbar from "../../components/Topbar";
import Sidebar from "../../components/Sidebar";
import { getUser } from "../../utils/Common";
import { useNavigate,useParams } from "react-router-dom";
import DataTable from 'react-data-table-component';
import moment from "moment";

const Property = ({ setIsAuthenticated }) => {
  const navigate = useNavigate();
  const [isMiniSidebar, setMiniSidebar] = useState(false);
  const { url,hotel_id } = useParams();
  const [transactionList, setTransactionList] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [userData, setUserData] = useState([]);
  const [propData, setPropData] = useState([]);
  
  const handleRowClick = (phoneNo) => {
    console.log(phoneNo);
    navigate(`/detail/transaction/${phoneNo}`);
  };
  const getDetailProperty = async (hotel_id) => {
    setLoading(true);
    try {
      const response = await axios.get(`/api/detail/hotel/${hotel_id}`);
      if (response.status === 200) {
        setPropData(response.data)
      } else {
        throw new Error('Query / network reloading');
      }
    } catch (err) {
      console.log("error");
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      name: "Booking ID",
      selector:  row => {
      return (
          <div
          className="flex items-center cursor-pointer"
          onClick={() => handleRowClick(row.phone)} // Navigate on row click
          >
          <HiClipboardList className="mr-1 text-gray-600" />
          <span>{row.booking_id} </span>
          </div>
      );},
      sortable: true,
      style: {
        width: '700px',  // Adjust the width here
        whiteSpace: 'nowrap'  // Optional: prevents text wrapping in case 'wrap' is set to false
      }
    },
    {
      name: "Guest Name",
      selector: row => `${row.salutation} ${row.firstname} ${row.lastname}`,
      sortable: true
    },
    {
      name: "Phone",
      selector: row => row.phone,
      sortable: true
    },
    {
      name: "Arrival Date",
      selector: row => moment(row.arrival_date).format('ll'),
      sortable: true,
      style: {
        width: '100px', 
      }
    },
    {
      name: "Departure Date",
      selector: row => moment(row.departure_date).format('ll'),
      sortable: true,
      style: {
        width: '100px', 
      }
    },
    {
      name: "Price",
      selector: row => 
        new Intl.NumberFormat('id-ID', {
          style: 'currency',
          currency: 'IDR',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }).format(Math.round(row.price)),
      sortable: true
    }
  ];

  useEffect(() => {
    var userHID = localStorage.getItem("hid");
    const userSession = getUser(); // Call getUser to fetch user data from localStorage
    
    if (userSession) {
      setUserData(userSession); // Store user data in the state if it exists
      getDetailProperty(userHID);
      const fetchData = async () => {
        // Store user data in the state if it exists
        setLoading(true); // Set loading state to true before making the API request
        try {

          var uid = userSession.id;
          var hotel = localStorage.getItem("hid");
          
          // Make sure the hotel_id exists before making the API request
          if (!hotel) {
            throw new Error('Hotel ID is missing');
          }

          // Sending the API request and awaiting the response
          const response = await axios.get(`/api/transaction/today/${hotel}`);
          // console.log(response.data)
          if (response.status === 200) {
            console.log(response.data.data)
            setTransactionList(response.data.data)
            
          } else {
            throw new Error('Failed to fetch property list');
          }
        } catch (err) {
          console.error('Error fetching data:', err);
          alert('An error occurred while fetching data.');
        } finally {
          setLoading(false); // Reset loading state after the API call is completed
        }
    };

      fetchData(); 
    } else {
      navigate('/'); // Optionally clear the user data if not found
    }
  }, []);

  return (
    <div className="flex h-screen bg-gray-200">
      {/* Sidebar */}
      <Sidebar setMiniSidebar={setMiniSidebar} isMiniSidebar={isMiniSidebar} propertyID={propData.ID_HOTEL || "Loading..."}/>

        {isLoading ? (
          /* Loading Indicator */
          <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg flex flex-col items-center">
              <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#0f1827] mb-4"></div>
              <p className="text-gray-700">Load Data...</p>
            </div>
          </div>
        ) : (
          <>

          <div className="flex-1 flex flex-col overflow-hidden">
            <Topbar setMiniSidebar={setMiniSidebar} isMiniSidebar={isMiniSidebar} />
            {/* Main Section */}
            <main className="flex-1 p-5 overflow-y-auto bg-gray-100">
              
              {/* Breadcrumb */}
              <div className="mb-4 text-xs text-[#101827]">
                <span>Ashley Hotel Group</span> &gt; <span>Home</span> &gt; <span>{propData.NAME_HOTEL}</span>
              </div>

              {/* Content Area */}
              <section className="bg-white rounded shadow-md py-4 px-6 text-[#101827] mb-6">
                <h2 className="text-base font-bold mb-4">Welcome back, {userData.name}</h2>
                <p className="text-gray-600 text-sm">This is {propData.NAME_HOTEL} page. Here list activity today  .</p>
              </section>

              <div className="bg-white rounded shadow-md py-4 px-6 text-[#101827] mb-6">
                <h6 className="text-sm">Transaction today</h6>
                <DataTable
                  className="text-sm"
                  columns={columns}
                  data={transactionList}
                  pagination
                  highlightOnHover
                  responsive
                />
              </div>

            </main>
          </div>
  
          </>
        )}
    </div>
  );
};

export default Property;
